import { render, staticRenderFns } from "./OrganismCartSpacesBuilding.vue?vue&type=template&id=1c22fe48&"
import script from "./OrganismCartSpacesBuilding.vue?vue&type=script&lang=js&"
export * from "./OrganismCartSpacesBuilding.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCartSpacesBuilding.vue?vue&type=style&index=0&id=1c22fe48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismCartSpacesBuilding.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Forganisms%2Fproject%2FbuildingV2%2FOrganismCartSpacesBuilding.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectBuildingV2MoleculeSpaceDetailsTotalResultCart: require('/app/components/molecules/project/buildingV2/MoleculeSpaceDetailsTotalResultCart.vue').default,AtomsCommonAtomSimpleButton: require('/app/components/atoms/common/AtomSimpleButton.vue').default})
